module.exports = __webpack_public_path__ + "img/elipse.b2eebaa8.png";